

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiConstant } from '../../config/apiconfig.const';


@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  constructor(
    private _http: HttpClient,
  ) { }

  onLoadGetProduct(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-txn-prditem` + queryparams);
  }


  onLoadGetProducts(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-txn-prditem/${id}` + queryparams);
  }


  onLoadCartIitem(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-txn-cartitem` + queryparams);
  }


  addToCart(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}products/save` + queryparams, body);
  }


  AddToCartItem(body, prditemId?: any, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}products/save-cart/${prditemId}` + queryparams, body);
  }


  AddToCart(body, prditemId?: any, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}products/save-cart/${prditemId}` + queryparams, body);
  }


  signUpUser(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}aboutus/save` + queryparams, body);
  }


  loginUser(mailid?: any, password?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-txn-reg/${mailid}/${password}` + queryparams);
  }


  deleteCartById(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/delete/${id}` + queryparams);
  }


  getSubTotal(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-total-amt` + queryparams);
  }

  deleteDiscPer(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/delete-disc-per` + queryparams);
  }


  updateCart(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}aboutus/update-cart-item` + queryparams, body);
  }


  getProductDesc(prdName?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-txn-prditem-desc/${prdName}` + queryparams);
  }

  getProductDescByName(prditemName?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-product-detail-by-product-name/${prditemName}` + queryparams);
  }


  getProductCategory(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-category` + queryparams);
  }


  getEvergreenProducts(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-txn-prditem-evergreen` + queryparams);
  }


  getBlendedSpices(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-txn-prditem-blended` + queryparams);
  }


  getAchaarDetails(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-txn-prditem-achaar` + queryparams);
  }


  logoutUser(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/logout` + queryparams);
  }


  getAllStoreList(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-all` + queryparams);
  }


  grtStoreAreaDetails(slocationId?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-txn-store/${slocationId}` + queryparams);
  }


  saveAddressDetails(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}aboutus/save1` + queryparams, body);
  }


  getCountryDropdown(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-mst-country` + queryparams);
  }


  getStateDropdown(countryid?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-mst-state/${countryid}` + queryparams);
  }


  getCityDropdown(stateId?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-mst-city/${stateId}` + queryparams);
  }


  saveAddress(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}aboutus/save-address-details` + queryparams, body);
  }


  getUserDetailsById(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-by-id/${id}` + queryparams);
  }


  getByIdBillingAddress(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-by-id-billing-address/${id}` + queryparams);
  }


  getBillingAddressId(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-billing-address-id` + queryparams);
  }


  getEmailInfo(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-email-info/${id}` + queryparams);
  }


  getUserInfo(userId?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-email-info/${userId}` + queryparams);
  }


  getUserAddressDetails(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-user-address-details` + queryparams);
  }


  onLoadGetShippingAddressDetails(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-user-shipping-address-details` + queryparams);
  }


  orderInfoById(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-order-info-by-id/${id}` + queryparams);
  }


  getOrderInfoById(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-order-info-by-id` + queryparams);
  }


  updateBillingAddress(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}aboutus/update-billing-address` + queryparams, body);
  }


  saveContactInfo(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}aboutus/save-contact-info` + queryparams, body);
  }


  saveFeedabackDetails(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}aboutus/save-feedaback-details` + queryparams, body);
  }


  getShippingAddressId(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-shipping-address-id` + queryparams);
  }


  getByIdShippingAddress(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-by-id-shipping-address/${id}` + queryparams);
  }


  getUserIdBySession(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-user-id` + queryparams);
  }


  getBillingAddByUserId(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-billing-address-by-user-id/${id}` + queryparams);
  }


  getShippingAdrById(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-shipping-address-by-user-id/${id}` + queryparams);
  }


  updateCartOnPlaceOrder(queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}aboutus/update-txn-cart` + queryparams, null);
  }


  getOrderSummary(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-order-summary` + queryparams);
  }


  getOrderSummaryAmt(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-order-summary-amt` + queryparams);
  }


  sendMailFromContactUs(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}contact/send-mail-from-contact-us` + queryparams, body);
  }


  sendMailFromFeedaback(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}contact/send-mail-from-feedaback` + queryparams, body);
  }


  AssignCoupon(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}aboutus/assign-coupon` + queryparams, body);
  }


  getTotalQty(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-total-cart-qty` + queryparams);
  }


  applyCoupon(couponCode?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-mst-coupon/${couponCode}` + queryparams);
  }


  getProductDescriptionById(prditemId?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-product-detail-by-txn-prditem/${prditemId}` + queryparams);
  }


  getProductDescriptionById1(prditemId?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-product-detail-by-txn-prditem/${prditemId}` + queryparams);
  }
  getProductDescriptionByName(prditemName?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-product-detail-by-product-name/${prditemName}` + queryparams);
  }


  getOrderHistory(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-order-history/${id}` + queryparams);
  }

  getCancelOrderHistory(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-cancel-order-history/${id}` + queryparams);
  }

  getPendingOrderHistory(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-pending-order-history/${id}` + queryparams);
  }


  getOrderSummaryHistory(id?: any, userId?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-order-history-summary/${id}/${userId}` + queryparams);
  }


  getOrderHistoryAmtDetails(id?: any, userId?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-order-history-summary-amt/${id}/${userId}` + queryparams);
  }


  getOrderBillingDetails(id?: any, userId?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-order-summary-billing-address-details/${id}/${userId}` + queryparams);
  }


  getOrderShippingDetails(id?: any, userId?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-order-summary-shipping-address-details/${id}/${userId}` + queryparams);
  }


  saveCouponAdmin(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}stores/save-coupon-admin` + queryparams, body);
  }


  getAllMstCouponData(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-all-mst-coupon` + queryparams);
  }


  getAllCouponTypeData(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-all-coupon-type-name` + queryparams);
  }


  saveTxnCoupon(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}stores/save-txn-cpn` + queryparams, body);
  }


  getAllTxnCpnData(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-all-txn-cpn-data` + queryparams);
  }

  getAllValidTxnCpnData( queryparams: any = '') {
    const userId = sessionStorage.getItem('userId');
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-valid-cpn-data/${userId}` + queryparams);
  }

  deleteTxnCpnById(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/delete/${id}` + queryparams);
  }


  getByIdTxnCpnData(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-by-id-txn-cpn-data/${id}` + queryparams);
  }


  updateTxnCpn(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}stores/update` + queryparams, body);
  }


  getAllUserDetailsForDropdown(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-all-users` + queryparams);
  }


  saveTxnAsnCpnData(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}stores/save` + queryparams, body);
  }


  getAllTxnAsnCpnDataForGrid(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-all-txn-assignn-cpn-data` + queryparams);
  }


  deleteTxnAssignCpnById(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/delete-txn-assign-cpn/${id}` + queryparams);
  }


  getByIdTxnAssignCpnData(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-by-id-txn-assign-cpn-data/${id}` + queryparams);
  }


  updateTxnAssignCpnData(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}stores/update-txn-assign-cpn` + queryparams, body);
  }

  saveTxnCpnCon(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}stores/save-txn-cpn-con` + queryparams, body);
  }

  getAllTxnCpnConDataForGrid(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-all-txn-cpn-con-data` + queryparams);
  }

  getByIdTxnCpnConData(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-by-id-txn-cpn-con-data/${id}` + queryparams);
  }

  updateTxnCpnConData(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}stores/update-txn-cpn-con` + queryparams, body);
  }

  deleteTxnCpnCon(id?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/delete-txn-cpn-con-data/${id}` + queryparams);
  }

  getPaymentStatus(orderId: any) {
    return this._http.get(`${apiConstant.projectBaseUrl}order/get-order-status/${orderId}`);
  }

  getProductDetailByProductName(productName?: any, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}products/get-product-detail-by-prd-name/${productName}` + queryparams);
  }

  getUserCity(queryparams: any = '') {

    const userId = sessionStorage.getItem('userId');
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-user-city/${userId}` + queryparams);
  }

  loginUsers(body, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}auth/login` + queryparams, body);
  }

  getApprovedFeedbackMessages(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-approved-feedback-messages` + queryparams
    );
  }
  getAllBnnerImages(queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}stores/get-all-bannerphoto-list` + queryparams
    );
  }
  sendMailForReset(mail: string, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/send-mail/${mail}` + queryparams
    )
  }
  sendOtpForResetPassword(mail_id: number, otp: string, queryparams: any = '') {
    return this._http.get(
      `${apiConstant.projectBaseUrl}aboutus/get-otp/${mail_id}/${otp}` + queryparams
    )
  }
  updatePassword(body: any, queryparams: any = '') {
    return this._http.post(
      `${apiConstant.projectBaseUrl}aboutus/reset-password` + queryparams, body
    )
  }

}
